import { createFileRoute } from '@tanstack/react-router'
import { BillingSettingsPage } from '../components/billing-settings'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/impostazioni/abbonamento')({
  head: () => noIndexRouteHead('settingsBilling', 'it'),
  component: BillingSettingsPage,
})
